import { useRouter } from 'next/router';
import React, { ChangeEvent, useState } from 'react';
import styled from 'styled-components';
import Button from '../../ui/Button';
import Image from 'next/image';

const SearchIcon = '/img/icons/search.png';

export default function Search(){
  const router = useRouter();
  const [search, setSearch] = useState('');

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  }

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if(search.length > 2) {
      if (router.query.obj_id) {
        router.push({pathname: `/search/${search}`, query: {obj_id: router.query.obj_id}});
      }
      else router.push(`/search/${search}`);
      
    }
  }

  return <Container>
    <div className="maxwidth">
      <SearchBox onSubmit={submitHandler}>
        <input type="text" placeholder="Что Вы ищете?" onChange={changeHandler} value={search} id="main-search" />
        <Image src={SearchIcon} alt="" width={21} height={20} />
        <Button fontSize={'20px'} onClick={submitHandler}>Найти</Button>
      </SearchBox>
    </div>
  </Container>
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border-bottom: 1px solid #eee;
  padding: 5px 0;
`

const SearchBox = styled.form`
  width: calc(100% + 40px);
  height: 55px;
  transform: translateX(-20px);
  position: relative;

  & input {
    width: 100%;
    height: 100%;
    background-color: var(--color-bg-gray);
    background-position: left 20px center;
    padding: 0 20px 0 50px;
    border-radius: 14px !important;
    font-size: 18px;
    color: var(--color-text);
  }

  & img {
    position: absolute;
    left: 20px;
    width: 20px;
    height: auto;
    top: 50%;
    transform: translateY(-50%);
  }

  & a {
    position: absolute;
    right: 20px;
    top: 8px;
  }

  @media (max-width: 480px) {
    width: calc(100% + 20px);
    transform: translateX(-10px);

    & img {
      left: 10px;
    }

    & a {
      right: 10px;
      min-width: initial !important;
    }

    & input {
      background-position: left 10px center;
      padding: 0 10px 0 35px;
      border-radius: 5px !important;
      font-size: 16px;
    }
  }
`